import React, { useState } from 'react';

import { AnimatePresence } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

import { useBreakpoints } from '@pkg/hooks';

import { Cube } from './Cube';

import { EditButton, Wrapper } from './styles';

interface Props {
    width?: number;
    to?: string;
    showDelay?: number;
    skipIntro?: boolean;
    currentFaceIndex?: number;
    setCurrentFaceIndex?: (index: number) => void;
    freezeCube?: boolean;
    setFreezeCube?: (freezeCube: boolean) => void;
    isPageOwner?: boolean;
    showEditButton?: boolean;
    liquidIDItems?: any[]; // eslint-disable-line @typescript-eslint/no-explicit-any
    isLoading?: boolean;
    hideBackground?: boolean;
}

export const LiquidID = ({
    width = 500,
    to,
    showDelay = 0,
    skipIntro,
    currentFaceIndex,
    setCurrentFaceIndex,
    freezeCube,
    setFreezeCube,
    isPageOwner,
    showEditButton,
    liquidIDItems,
    isLoading,
    hideBackground,
}: Props) => {
    const navigate = useNavigate();

    const [isDragging, setIsDragging] = useState(false);
    const [isHovering, setIsHovering] = useState(false);

    const { isMobile } = useBreakpoints();

    const handleClick = () => {
        if (isDragging) return;
        if (to) {
            navigate(to);
        }
    };

    const setIsDraggingWithDelay = (value: boolean) => {
        if (!value) {
            setTimeout(() => setIsDragging(value), 200);
        } else {
            setIsDragging(value);
        }
    };

    return (
        <Wrapper onClick={handleClick} layoutId="liquidid-layout">
            {showEditButton && (
                <AnimatePresence>
                    {isHovering && (
                        <EditButton
                            initial={{ opacity: 0, y: 20, x: '-50%' }}
                            animate={{ opacity: 1, y: 0, x: '-50%' }}
                            exit={{ opacity: 0, y: 20, x: '-50%' }}
                        >
                            Edit
                        </EditButton>
                    )}
                </AnimatePresence>
            )}
            <Cube
                width={width}
                data={liquidIDItems}
                isLoading={isLoading}
                disableHover={!to || isMobile}
                isDragging={isDragging}
                setIsDragging={setIsDraggingWithDelay}
                isHovering={isHovering}
                setIsHovering={setIsHovering}
                showDelay={showDelay}
                skipIntro={skipIntro}
                currentFaceIndex={currentFaceIndex}
                setCurrentFaceIndex={setCurrentFaceIndex}
                freezeCube={freezeCube}
                setFreezeCube={setFreezeCube}
                isPageOwner={isPageOwner}
                hideBackground={hideBackground}
            />
        </Wrapper>
    );
};
